@if (aboutref | async; as item) {
  <section>
    <div class="row-flex page-references">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 px-sm-20 mb-30">
        @if (item?.h2content) {
          <p class="references-h2content">{{item.h2content}}</p>
        }
        <p class="about-ref" [innerHTML]="item.content"></p>
      </div>
    </div>
  </section>
}